import api from './api';

/**
 * Dashboard Service
 * Handles dashboard statistics API calls
 */
const dashboardService = {
    /**
     * Get dashboard statistics
     * @returns {Promise<Object>}
     */
    getStats: async () => {
        return api.get('/user/dashboard/stats');
    }
};

export default dashboardService;
